<template>
  <div>
    <el-carousel :interval='3000' type='card' style='padding: 0px; margin: 0px;' height='280px'>
      <el-carousel-item v-for='item in imagesbox' :key='item.id'>
        <img :src='item.idView' class='opacity'>
       </el-carousel-item>
    </el-carousel>
    <div class='solution' style=' margin:0 auto; width:1100px;'>
      <ul class='clearfix'>
        <li v-for='it in pngBox' :key='it.id'>
          <a :href='it.href' target='blank'>
            <img :src='it.idView' alt>
            <h3>{{it.name}}</h3>
            <p>{{it.desc}}</p>
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Index',
  metaInfo: {
    title: '主页'
  },
  data () {
    return {
      bannerHeight: '',
      imagesbox: [
        { id: 0, idView: require('../../public/images/wms/image1.jpg') },
        { id: 1, idView: require('../../public/images/wms/image2.jpg') },
        { id: 2, idView: require('../../public/images/wms/image3.jpg') }
      ],
      pngBox: [
        { id: 0, idView: require('../../public/images/wms/b1.png'), name: 'MES精益生产', desc: '智能工厂整体解决方案', href: 'http://www.dbkeji.com/solution.php?doid=100' },
        { id: 1, idView: require('../../public/images/wms/b2.png'), name: '仓库WMS', desc: '企业物流管理方案', href: 'http://www.dbkeji.com/solution.php?doid=101' },
        { id: 2, idView: require('../../public/images/wms/b3.png'), name: '软件定制开发', desc: '综合业务运营', href: 'http://www.dbkeji.com/solution.php?doid=96' },
        { id: 3, idView: require('../../public/images/wms/b4.png'), name: '金蝶云星空', desc: '面向中大型企业', href: 'http://www.dbkeji.com/solution.php?doid=69' },
        { id: 4, idView: require('../../public/images/wms/b5.png'), name: '金蝶K/3 WISE', desc: '面向中小型企业', href: 'http://www.dbkeji.com/solution.php?doid=98' },
        { id: 5, idView: require('../../public/images/wms/b6.png'), name: '金蝶KIS', desc: '面向小微企业', href: 'http://www.dbkeji.com/solution.php?doid=70' }
      ]
    }
  }
}
</script>
<style scoped>
  .opacity {
   width: 100%;
   height: 280px;
   filter: alpha(opacity=80);
   -moz-opacity: 0.8;
   -khtml-opacity: 0.8;
   opacity: 0.8;
  }
  .el-carousel__item h3 {
    color: #475669;
    font-size: 14px;
    opacity: 0.75;
    line-height: 200px;
    margin: 0;
  }
  .el-carousel__item:nth-child(2n) {
    background-color: #99a9bf;
  }
  .el-carousel__item:nth-child(2n+1) {
    background-color: #d3dce6;
  }

  @media screen and (min-width:1001px) {
    .solution{ padding-bottom:0px;}
    .solution ul{ margin:0 -10px;}
    .solution ul li{ float:left; width:150px; padding:0 10px; text-align:center;}
    .solution ul li a{ display:block; background:#ededed; padding:40px 0;}
    .solution ul li a img{ width:90px; height:75px; margin-bottom:40px; transition:all ease-out 0.3s;}
    .solution ul li a:hover img{ transform: rotateY(180deg); -webkit-transform: rotateY(180deg);/* Safari å’Œ Chrome */ -moz-transform: rotateY(180deg);/* Firefox */}
    .solution ul li a h3{ font-size:18px; color:#666; margin-bottom:5px; font-weight:normal;}
    .solution ul li a p{ font-size:12px; color:#999;}
  }
  @media only screen and (min-width:721px) and (max-width:1000px){
    .solution{ padding:0 0 20px 20px;}
    .solution ul:after{ display:block; content:''; height:0; visibility:hidden;}
    .solution ul li{ float:left; width:50%; text-align:center; margin-bottom:20px;}
    .solution ul li a{ display:block; background:#f9f9f9; padding:10px 0; margin-right:20px; border:1px solid #eee;}
    .solution ul li a img{ width:90px; height:75px; margin-bottom:10px; transition:all ease-out 0.3s;}
    .solution ul li a:hover img{ transform: rotateY(180deg); -webkit-transform: rotateY(180deg);/* Safari å’Œ Chrome */ -moz-transform: rotateY(180deg);/* Firefox */}
    .solution ul li a h3{ font-size:14px; color:#666; font-weight:normal;}
    .solution ul li a p{ font-size:12px; color:#999;}
  }
  @media only screen and (min-width:461px) and (max-width:720px){
    .solution{ padding:0 0 20px 20px;}
    .solution ul:after{ display:block; content:''; height:0; visibility:hidden;}
    .solution ul li{ float:left; width:50%; text-align:center; margin-bottom:20px;}
    .solution ul li a{ display:block; background:#f9f9f9; padding:10px 0; margin-right:20px; border:1px solid #eee;}
    .solution ul li a img{ width:90px; height:75px; margin-bottom:10px; transition:all ease-out 0.3s;}
    .solution ul li a:hover img{ transform: rotateY(180deg); -webkit-transform: rotateY(180deg);/* Safari å’Œ Chrome */ -moz-transform: rotateY(180deg);/* Firefox */}
    .solution ul li a h3{ font-size:14px; color:#666; font-weight:normal;}
    .solution ul li a p{ font-size:12px; color:#999;}
  }

  @media only screen and (max-width:460px){
    .solution{ padding:0 20px 20px;}
    .solution ul:after{ display:block; content:''; height:0; visibility:hidden;}
    .solution ul li{ text-align:center; padding-bottom:20px;}
    .solution ul li a{ display:block; background:#f9f9f9; padding:10px 0; border:1px solid #eee;}
    .solution ul li a img{ width:90px; height:75px; margin-bottom:10px; transition:all ease-out 0.3s;}
    .solution ul li a:hover img{ transform: rotateY(180deg); -webkit-transform: rotateY(180deg);/* Safari å’Œ Chrome */ -moz-transform: rotateY(180deg);/* Firefox */}
    .solution ul li a h3{ font-size:14px; color:#666; font-weight:normal;}
    .solution ul li a p{ font-size:12px; color:#999;}
  }

  a { text-decoration:none; outline:none; transition:all ease-out 0.3s; color:#333;}
  a:hover { text-decoration:none;}
  ul,ol{ list-style:none;}
  .clearfix:before,.clearfix:after{ content:''; display:table;} .clearfix:after{clear:both;} .clearfix{ *zoom:1;/*IE/7/6*/}
</style>
